import Vue from 'vue';
import { LoadingStatus } from '@pjn/core/ui/loading';
import { Store } from '@pjn/vue-core/store';
import { Mutation } from '@pjn/vue-core/store/annotations';
import { denunciaService } from '@/services';
import { OptionalId } from '@pjn/core/model/helpers/Types';

import Denuncia from '@/model/Denuncia';

/**
 * Store que consulta y actualiza denuncias
 */
@Store
export default class DenunciaStore extends Vue {
  denuncia: OptionalId<Denuncia> | null;

  /** Estado de carga de (para mostrar loader). */
  status: LoadingStatus = {};
 


  async load(id) {
    this.beginRequest();
    try {
      const denuncia = await denunciaService.findById(id)
      this.loadSuccess(denuncia);
      return { ...denuncia };
    } catch (e) {
      this.loadFail();
      return null;
    }
  }

    async reload() {
    if (this.denuncia?.id) {
      if (
        await this.load(
          this.denuncia.id
        )
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * Guarda el denuncia
   */
  async save(unDenuncia = this.denuncia) {
    try {
      const denuncia: Denuncia | null = unDenuncia ?  await denunciaService.save(unDenuncia) : null
      denuncia ? this.loadSuccess(denuncia) : this.loadFail()
      return denuncia;
    } catch (e) {
      
      this.fail();
      throw e;
    }
  }

  async delete(id: number) {

    await denunciaService.delete(id);
    this.loadFail()
   
}
 
 
  @Mutation
  private beginRequest() {
    this.status = { loading: true };
  }

  @Mutation
  private loadSuccess(denuncia: Denuncia) {
    this.status = {};
    this.denuncia = denuncia;
  }

  @Mutation
  private updateSuccess(denuncia: OptionalId<Denuncia>) {
    this.denuncia = denuncia;

    return true;
  }
 

  @Mutation
  private loadFail() {
    this.status = { error: true };
    this.denuncia = null;
  }

  @Mutation
  private fail() {
    this.status = { error: true };
  }
}
